import $ from "jquery-upstream";
import {bootstrap} from "./bootstrap";
import {pickadate} from "./pickadate";

bootstrap($);
pickadate($);

export default $;
export {$ as jQuery, $ as jquery};
